import { Typography } from "@mui/material";

export default function Map() {
  return <Typography>Admin Map Page</Typography>;
}
